import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/pages/login/Login'
import CorCert from '@/pages/corCert/CorCert'
import NotAllow from '@/pages/guide/NotAllow'

Vue.use(Router)

export default new Router({
  routes: [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/',
        component: resolve => require(['../pages/home/Home.vue'], resolve),
        meta: { title: '自述文件' },
        children:[
            {
                path: '/index',
                component: resolve => require(['../pages/home/components/Index.vue'], resolve),
                meta: { title: '系统首页' }
            },
            {
                path: '/corres',
                component: resolve => require(['../pages/home/components/corResource.vue'], resolve),
                meta: { title: '公司资源' }
            },
            {
                path: '/cusmanage',
                component: resolve => require(['../pages/home/components/CustomerManage.vue'], resolve),
                meta: { title: '客户管理' }
            },
            {
                path: '/employees',
                component: resolve => require(['../pages/home/components/EmployeesManage.vue'], resolve),
                meta: { title: '员工管理' }
            },
            {
                path: '/companyinfo',
                component: resolve => require(['../pages/home/components/CompanyInfo.vue'], resolve),
                meta: { title: '公司信息' }
            },
        ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/corCert',
      name: 'CorCert',
      component: CorCert
    },
    {
      path: '/notallow',
      name: 'NotAllow',
      component: NotAllow
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js